module.exports = __webpack_public_path__ + "static/img/pic_zbyy.6a15233.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/pic_zbyy.png
// module id = 7Lip
// module chunks = 0